import React from "react";
import _ from "lodash";
import {
  AccountBalanceOutlined,
  Alarm,
  AlternateEmailOutlined,
  AssignmentIndOutlined,
  AssignmentTurnedInOutlined,
  AssignmentTurnedInOutlined as CreateDocument,
  BallotOutlined,
  Edit,
  CallOutlined as Call,
  ContactPhoneOutlined as LawyerCall,
  DateRangeOutlined as CourtDate,
  DescriptionOutlined as Document,
  EditNote,
  EventAvailable,
  ForwardToInbox,
  MarkunreadMailboxOutlined,
  ReportProblemOutlined,
  RotateLeft,
  SmsOutlined,
  SpeakerNotesOutlined,
  WorkOutlineOutlined as Lawyer,
} from "@mui/icons-material";
import { ActivityType } from "../../types/Activities/ActivityType";

const litigationActivityTypes = [
  {
    name: "create_extrajudicial_letter",
    label: "Außergerichtliches Schreiben erstellen",
    icon: <EditNote color={"secondary"} />,
    prefillDescription: true,
    defaultDuration: 15,
  },
  {
    name: "court_date",
    label: "Gerichtstermin",
    icon: <CourtDate color={"secondary"} />,
    prefillDescription: true,
  },
  {
    name: "announcement_date",
    label: "Verkündungstermin",
    icon: <CourtDate color={"secondary"} />,
    prefillDescription: true,
  },
  {
    name: "request_payment_order",
    label: "Mahnbescheid beantragen",
    icon: <Edit color={"secondary"} />,
    prefillDescription: true,
    defaultDuration: 20,
    noteToPrefill:
      "<ul>" +
      "<li>Welche Forderung?</li>" +
      "<li>Aus was?(Katalog-Nr.) Kaufvertrag</li>" +
      "<li>Wann beauftragt?</li>" +
      "<li>Von wann ist der Anspruch?</li>" +
      "<li>Zinsen auf die Forderung und ab wann?</li>" +
      "<li>vorgerichtliche Rechtsanwaltskosten? Wenn ja Zinsen und ab wann?</li>" +
      "<li>Streitiges Verfahren bei Widerspruch gewünscht?  Ja oder Nein</li>" +
      "<li>Anspruch abhängig von Gegenleistung? Ja oder Nein</li>" +
      "</ul>",
  },
];

const trafficAccidentTypes = [...litigationActivityTypes];

const activityTypes = {
  general: [
    {
      name: "no_type",
      label: "Kein Typ",
      icon: <BallotOutlined color={"secondary"} />,
      disabled: true,
      prefillDescription: true,
    },
    {
      name: "client_call",
      label: "Beratungstermin (manuell vereinbart)",
      icon: <LawyerCall color={"secondary"} />,
      prefillDescription: true,
      defaultDuration: 15,
    },
    {
      name: "lawyer_counseling_call",
      label: "Beratungstermin",
      icon: <LawyerCall color={"secondary"} />,
      disabled: true,
      prefillDescription: true,
      isHidden: true,
    },
    {
      name: "callback_appointment",
      label: "Rückruf",
      icon: <LawyerCall color={"secondary"} />,
      disabled: true,
      prefillDescription: true,
      isHidden: true,
    },
    {
      name: "calendly_event",
      label: "Beratungstermin",
      icon: <LawyerCall color={"secondary"} />,
      disabled: true,
      prefillDescription: true,
      isHidden: true,
    },
    {
      name: "follow_up",
      label: "Nachfass",
      icon: <Call color={"secondary"} />,
      prefillDescription: false,
    },
    {
      name: "inbound_call",
      label: "Inbound PhoneCall",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "accountmanager_task",
      label: "KB Tätigkeit",
      icon: <AssignmentIndOutlined color={"secondary"} />,
      prefillDescription: false,
    },
    {
      name: "mandate_activity",
      label: "Mandatstätigkeit",
      icon: <Lawyer color={"secondary"} />,
      prefillDescription: false,
      defaultDuration: 3,
    },
    {
      name: "create_legal_document",
      label: "Schriftsatz erstellen",
      icon: <EditNote color={"secondary"} />,
      prefillDescription: true,
      defaultDuration: 30,
    },
    {
      name: "check_document",
      label: "Dokument prüfen",
      icon: <Document color={"secondary"} />,
      anchor: "#documents",
      prefillDescription: true,
    },
    {
      name: "check_payment",
      label: "Zahlungseingang prüfen",
      icon: <Alarm color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "accounting",
      label: "Buchhaltung",
      icon: <AccountBalanceOutlined color={"secondary"} />,
      prefillDescription: false,
    },
    {
      name: "check_status",
      label: "Statuscheck",
      icon: <RotateLeft color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "deadline",
      label: "Frist",
      icon: <Alarm color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "internal_deadline",
      label: "Interne Frist",
      icon: <EventAvailable color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "peremptory_term",
      label: "Notfrist",
      icon: <ReportProblemOutlined color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "mail",
      label: "Post",
      icon: <MarkunreadMailboxOutlined color={"secondary"} />,
      prefillDescription: false,
      anchor: "#documents",
    },
    {
      name: "email",
      label: "E-Mail",
      icon: <AlternateEmailOutlined color={"secondary"} />,
      anchor: "#mails",
      prefillDescription: false,
    },
    {
      name: "check_case",
      label: "Fallprüfung",
      icon: <AssignmentTurnedInOutlined color={"secondary"} />,
      prefillDescription: true,
      defaultDuration: 15,
      noteToPrefill: `
        Bitte Fall wie folgt prüfen.

        <ul>
            <li>
                Fällt der Fall in ein Rechtsgebiet bzw. handelt es sich um eine Art Rechtsstreit, den wir übernehmen und Erfolgsaussichten hat?
                <ul>
                    <li>Wenn der Fall an eine Koop-RSV zurückgeht, bitte <a href="https://legalbird.atlassian.net/wiki/spaces/kooperationen/pages/4200497153/Workflow+R+ckgabe+von+Mandaten+an+RSV+Kooperationspartner" target="_blank">workflow</a> beachten.</li>
                    <li>Wenn keine Anspruchsgrundlage besteht oder nicht (mehr) durchsetzbar ist, entsprechend “Kein weiteres Vorgehen / rechtliche Grundlage ?” auswählen, Pflichtfelder befüllen und Fall auf “Überprüft” schieben, damit er abgeschlossen wird.</li>
                </ul>
            </li>
        </ul>

        <p>
            <strong>Wenn der Fall übernommen wird prüfen:</strong>
        </p>

        <ul>
            <li>Ist der Fall vollständig und juristisch prüfbar? Ist der Anspruchsinhaber unser Mandant und der/die Anspruchsgegnerin als Gegenseite eingetragen? Hat der Mandant wirksam die Vollmacht unterzeichnet?</li>
            <li>Habe ich alle Informationen und Unterlagen, um den Sachverhalt rechtlich durchzusetzen?</li>
            <li>Ist die Fallzusammenfassung korrekt und werden Mandantenbegehren und Anspruchsgrundlagen richtig dargestellt?</li>
            <li>Habe ich alle Informationen und Unterlagen, um den Sachverhalt rechtlich durchzusetzen?</li>
            <li>Sind Vertragsschluss, Forderungen, bisherige Korrespondenz und/oder die rechtliche Ausgangslage ausreichend nachvollziehbar um substantiiert dargelegt werden zu können?</li>
            <li>Sind Fristen, Verjährung, Zuständigkeit oder sonstige rechtliche Risiken erkennbar?</li>
        </ul>

        <p>
            <strong>Wenn wir den Fall übernehmen und alles vorliegt:</strong>
        </p>

        <ul>
            <li>bitte ggfs. Fallzusammenfassung korrigieren / vervollständigen.</li>
            <li>bitte Pflichtfelder befüllen und Stage auf “Daten Anwalt vollständig” schieben.</li>
        </ul>

        <p>
            <strong>Wenn Fall noch nicht vollständig,</strong>
        </p>

        <ul>
            <li>
                bitte Anfrage-Funktion nutzen, um fehlende Unterlagen oder Informationen anzufragen
                <ul>
                    <li>Wichtig beim Stellen von Anfragen in diesem Status: Immer das Feld „Bei fehlender Rückmeldung“ mit „Keine weitere Bearbeitung notwendig“ befüllen. Es wird so automatisch bei der Mandantschaft nachgefasst und der Fall inaktiv gestellt, wenn keine Rückmeldung mehr kommt.</li>
                    <li><strong>Abseits der automatischen Erinnerung im Zuge der Anfrage machen wir keine weitergehenden (und vor allem keine manuellen!) Nachfasse.</strong></li>
                </ul>
            </li>
         </ul>`,
    },
    {
      name: "send_via_bea",
      label: "Versand per beA",
      icon: <ForwardToInbox />,
      prefillDescription: true,
    },
    {
      name: "representative",
      label: "Terminsvertreter",
      icon: <Lawyer color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "call_notes",
      label: "Gesprächsnotiz",
      icon: <SpeakerNotesOutlined color={"secondary"} />,
      prefillDescription: true,
      disabled: true,
      isHidden: true,
    },
    {
      name: "message",
      label: "Nachricht",
      icon: <SmsOutlined color={"secondary"} />,
      prefillDescription: true,
      disabled: true,
      anchor: "#messages",
    },
  ],
  divorce: [
    {
      name: "status_1_call",
      label: "Status 1 PhoneCall",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "initial_call",
      label: "Ersttelefonat",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "create_divorce_application",
      label: "Scheidungsantrag erstellen",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "send_document_to_customer",
      label: "Dokument an Kunden schicken",
      icon: <Document color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "submit_divorce",
      label: "Scheidung einreichen",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "court_date",
      label: "Gerichtstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "announcement_date",
      label: "Verkündungstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
  ],
  settlement: [
    {
      name: "status_1_call",
      label: "Status 1 PhoneCall",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "initial_call",
      label: "Ersttelefonat",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "create_dismissal_protection_suit",
      label: "Klage erstellen",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "court_date",
      label: "Gerichtstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "announcement_date",
      label: "Verkündungstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "send_document_to_customer",
      label: "Dokument an Kunden schicken",
      icon: <Document color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "submit_dismissal_protection_suit",
      label: "Klage einreichen",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
  ],
  traffic: [
    {
      name: "write_plea",
      label: "Einlassung schreiben",
      icon: <EditNote color={"secondary"} />,
      defaultDuration: 15,
      prefillDescription: true,
    },
    {
      name: "initial_call",
      label: "Ersttelefonat",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "send_document_to_customer",
      label: "Dokument an Kunden schicken",
      icon: <Document color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "access_to_records",
      label: "Einspruch/Akteneinsicht",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "submit_opinion",
      label: "Stellungnahme schicken",
      icon: <CreateDocument color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "court_date",
      label: "Gerichtstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "announcement_date",
      label: "Verkündungstermin",
      icon: <CourtDate color={"secondary"} />,
      prefillDescription: true,
    },
    {
      name: "status_1_call",
      label: "Status 1 PhoneCall",
      icon: <Call color={"secondary"} />,
      prefillDescription: true,
    },
  ],
  trafficAccident: trafficAccidentTypes,
  eventContract: litigationActivityTypes,
  membershipContract: litigationActivityTypes,
  otherContract: litigationActivityTypes,
  providerContract: litigationActivityTypes,
  dataLeakContract: litigationActivityTypes,
  purchaseContract: litigationActivityTypes,
  rentalContract: litigationActivityTypes,
  serviceContract: litigationActivityTypes,
  subscriptionContract: litigationActivityTypes,
  travelContract: litigationActivityTypes,
  vehicleContract: litigationActivityTypes,
  generalCivilLaw: litigationActivityTypes,
  employmentContract: litigationActivityTypes,
  civilServiceLaw: litigationActivityTypes,
};

export const deadlineActivityTypes = ["deadline", "peremptory_term", "internal_deadline"];

export const lawyerCallActivityTypes = ["lawyer_counseling_call", "client_call", "calendly_event"];

export function getActivitiesSet(productClassName: string) {
  const generalActivityTypesCopy = _.cloneDeep(activityTypes.general);
  const productActivityTypesCopy = _.cloneDeep(_.get(activityTypes, productClassName, []));
  const combinedActivityTypes = [...generalActivityTypesCopy, ...productActivityTypesCopy];
  return _.uniqBy(combinedActivityTypes, (activityType) => activityType.name);
}

export function getFullActivitiesSet() {
  const allActivityTypes = [
    ..._.cloneDeep(activityTypes.divorce),
    ..._.cloneDeep(activityTypes.settlement),
    ..._.cloneDeep(activityTypes.traffic),
    ..._.cloneDeep(litigationActivityTypes),
    ..._.cloneDeep(activityTypes.general),
  ];
  return _.sortBy(
    _.uniqBy(allActivityTypes, (activityType) => activityType.name),
    "label"
  );
}

export function getDeadlinesActivitiesSet() {
  const allActivityTypes = [
    ..._.cloneDeep(activityTypes.divorce),
    ..._.cloneDeep(activityTypes.settlement),
    ..._.cloneDeep(activityTypes.traffic),
    ..._.cloneDeep(litigationActivityTypes),
    ..._.cloneDeep(activityTypes.general),
  ];
  const allDeadlineActivityTypes = _.filter(allActivityTypes, (activityType) =>
    _.includes(deadlineActivityTypes, activityType.name)
  );
  return _.sortBy(
    _.uniqBy(allDeadlineActivityTypes, (activityType) => activityType.name),
    "label"
  );
}

export function getActivityIcon(productClassName: string, activityName: string) {
  return _.get(
    _.find(getActivitiesSet(productClassName), (activity) => activity.name === activityName),
    "icon",
    <>{activityName}</>
  );
}

export function getActivityAnchor(productClassName: string, activityName: string) {
  return _.get(
    _.find(getActivitiesSet(productClassName), (activity) => activity.name === activityName),
    "anchor"
  );
}

export function getActivityLabel(productClassName: string, activityName: string) {
  return _.get(
    _.find(getActivitiesSet(productClassName), (activity) => activity.name === activityName),
    "label",
    "N/A"
  );
}

export function getActivityData(productClassName: string, activityName: string) {
  return _.find(getActivitiesSet(productClassName), (activity) => activity.name === activityName);
}

export function transformActivitySetToAutoCompleteOptions(activityTypes: ActivityType[]) {
  const allAutocompleteVisibleActivityTypes = activityTypes.filter((activityType) => !activityType.isHidden);
  return _.map(allAutocompleteVisibleActivityTypes, (activityType) => {
    return { label: activityType.label, id: activityType.name, disabled: activityType.disabled };
  });
}
